import { translate } from '@jsverse/transloco';

export function enumToArray(enumRef: any, translateKey: string): Array<any> {
    return Object.keys(enumRef)
      .filter((el) => parseInt(el, 10) >= 0)
      .map((el) => {
        return {
          id: parseInt(el, 10),
          name: translate(translateKey + enumRef[el]),
        };
      });
  }